import React, { useEffect } from 'react';
import Lottie, { LottieComponentProps } from 'lottie-react';
import LoadingAnimation from './animations/LoadingLoop_Grey.json';
import ConfirmCheck from './animations/ConfirmCheck.json';
import SparkleLoop from './animations/SparkleLoop.json';
import styled from 'styled-components';

export interface HeartLoadingProps {
    maxWidth?: number;
    showConfirmationAnimation?: boolean;
    onConfirmationAnimationCompleted?: () => unknown;
    className?: string;
}

const StyledDiv = styled('div').withConfig({
    shouldForwardProp: (prop) => prop !== 'maxWidth',
})<{ maxWidth?: number }>`
    ${({ maxWidth }) =>
        maxWidth
            ? `max-width: ${maxWidth}px; margin-left: auto; margin-right: auto;`
            : ''}
`;

export const HeartLoading: React.FC<HeartLoadingProps> = React.memo(
    ({
        maxWidth,
        showConfirmationAnimation,
        className,
        onConfirmationAnimationCompleted,
    }) => {
        const [lottieProps, setLottieProps] =
            React.useState<LottieComponentProps>();
        const startLoadingAnimation = () => {
            setLottieProps({
                animationData: LoadingAnimation,
                loop: true,
                autoplay: true,
            });
        };

        const startSparkleLoopAnimation = () => {
            setLottieProps({
                animationData: SparkleLoop,
                loop: true,
                autoplay: true,
            });
        };
        const startConfirmCheckAnimation = () => {
            setLottieProps({
                animationData: ConfirmCheck,
                loop: false,
                autoplay: true,
                onComplete: startSparkleLoopAnimation,
            });
        };
        useEffect(() => {
            startLoadingAnimation();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        useEffect(() => {
            if (showConfirmationAnimation) {
                startConfirmCheckAnimation();
                const timer = window.setTimeout(() => {
                    onConfirmationAnimationCompleted?.();
                }, 1800);
                return () => window.clearTimeout(timer);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [showConfirmationAnimation]);
        return (
            <StyledDiv
                maxWidth={maxWidth}
                className={className}
            >
                {lottieProps && (
                    <Lottie
                        {...lottieProps}
                        role="figure"
                        style={{
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden',
                            margin: '0 auto',
                        }}
                    />
                )}
            </StyledDiv>
        );
    },
);

HeartLoading.displayName = 'HeartLoading';
